import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React__default, { useEffect, useCallback, useState, useReducer, useRef } from 'react';
import useSendbirdStateContext from '../useSendbirdStateContext.js';
import { _ as _objectSpread2 } from '../_rollupPluginBabelHelpers-05128ded.js';
import '../withSendbird.js';
var GET_SEARCHED_MESSAGES = 'GET_SEARCHED_MESSAGES';
var GET_NEXT_SEARCHED_MESSAGES = 'GET_NEXT_SEARCHED_MESSAGES';
var START_MESSAGE_SEARCH = 'START_MESSAGE_SEARCH';
var START_GETTING_SEARCHED_MESSAGES = 'START_GETTING_SEARCHED_MESSAGES';
var SET_QUERY_INVALID = 'SET_QUERY_INVALID';
var SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';
var CHANNEL_INVALID = 'CHANNEL_INVALID';
var RESET_SEARCH_STRING = 'RESET_SEARCH_STRING';
function reducer(state, action) {
  switch (action.type) {
    case SET_CURRENT_CHANNEL:
      {
        var currentChannel = action.payload;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          currentChannel: currentChannel,
          initialized: true
        });
      }
    case CHANNEL_INVALID:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          currentChannel: null,
          initialized: false
        });
      }
    case GET_SEARCHED_MESSAGES:
      {
        var _action$payload = action.payload,
          messages = _action$payload.messages,
          createdQuery = _action$payload.createdQuery;
        if (createdQuery && createdQuery.channelUrl === (state === null || state === void 0 ? void 0 : state.currentMessageSearchQuery).channelUrl && createdQuery.key === (state === null || state === void 0 ? void 0 : state.currentMessageSearchQuery).key) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            loading: false,
            isInvalid: false,
            allMessages: _toConsumableArray(messages),
            hasMoreResult: (state === null || state === void 0 ? void 0 : state.currentMessageSearchQuery).hasNext
          });
        }
        return _objectSpread2({}, state);
      }
    case SET_QUERY_INVALID:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isInvalid: true
        });
      }
    case START_MESSAGE_SEARCH:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isInvalid: false,
          loading: false
        });
      }
    case START_GETTING_SEARCHED_MESSAGES:
      {
        var currentMessageSearchQuery = action.payload;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          loading: true,
          currentMessageSearchQuery: currentMessageSearchQuery
        });
      }
    case GET_NEXT_SEARCHED_MESSAGES:
      {
        var _messages = action.payload;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          allMessages: [].concat(_toConsumableArray(state.allMessages), _toConsumableArray(_messages)),
          hasMoreResult: (state === null || state === void 0 ? void 0 : state.currentMessageSearchQuery).hasNext
        });
      }
    case RESET_SEARCH_STRING:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          allMessages: []
        });
      }
    default:
      {
        return state;
      }
  }
}
var initialState = {
  allMessages: [],
  loading: false,
  isInvalid: false,
  initialized: false,
  currentChannel: null,
  currentMessageSearchQuery: null,
  hasMoreResult: false
};
function useSetChannel(_ref, _ref2) {
  var channelUrl = _ref.channelUrl,
    sdkInit = _ref.sdkInit;
  var sdk = _ref2.sdk,
    logger = _ref2.logger,
    messageSearchDispatcher = _ref2.messageSearchDispatcher;
  useEffect(function () {
    if (channelUrl && sdkInit && sdk !== null && sdk !== void 0 && sdk.groupChannel) {
      sdk.groupChannel.getChannel(channelUrl).then(function (groupChannel) {
        logger.info('MessageSearch | useSetChannel group channel', groupChannel);
        messageSearchDispatcher({
          type: SET_CURRENT_CHANNEL,
          payload: groupChannel
        });
      }).catch(function () {
        messageSearchDispatcher({
          type: CHANNEL_INVALID,
          payload: null
        });
      });
    }
  }, [channelUrl, sdkInit]);
}
var MessageSearchOrder = /*#__PURE__*/function (MessageSearchOrder) {
  MessageSearchOrder["SCORE"] = "score";
  MessageSearchOrder["TIMESTAMP"] = "ts";
  return MessageSearchOrder;
}(MessageSearchOrder || {});
function useGetSearchedMessages(_ref, _ref2) {
  var currentChannel = _ref.currentChannel,
    channelUrl = _ref.channelUrl,
    requestString = _ref.requestString,
    messageSearchQuery = _ref.messageSearchQuery,
    onResultLoaded = _ref.onResultLoaded,
    retryCount = _ref.retryCount;
  var sdk = _ref2.sdk,
    logger = _ref2.logger,
    messageSearchDispatcher = _ref2.messageSearchDispatcher;
  useEffect(function () {
    messageSearchDispatcher({
      type: START_MESSAGE_SEARCH,
      payload: null
    });
    if (sdk && channelUrl && sdk.createMessageSearchQuery && currentChannel) {
      if (requestString) {
        currentChannel.refresh().then(function (channel) {
          var inputSearchMessageQueryObject = _objectSpread2({
            order: MessageSearchOrder.TIMESTAMP,
            channelUrl: channelUrl,
            messageTimestampFrom: channel.invitedAt,
            keyword: requestString
          }, messageSearchQuery);
          var createdQuery = sdk.createMessageSearchQuery(inputSearchMessageQueryObject);
          createdQuery.next().then(function (messages) {
            logger.info('MessageSearch | useGetSearchedMessages: succeeded getting messages', messages);
            messageSearchDispatcher({
              type: GET_SEARCHED_MESSAGES,
              payload: {
                messages: messages,
                createdQuery: createdQuery
              }
            });
            if (onResultLoaded && typeof onResultLoaded === 'function') {
              onResultLoaded(messages, null);
            }
          }).catch(function (error) {
            logger.warning('MessageSearch | useGetSearchedMessages: getting failed', error);
            messageSearchDispatcher({
              type: SET_QUERY_INVALID,
              payload: null
            });
            if (onResultLoaded && typeof onResultLoaded === 'function') {
              onResultLoaded(null, error);
            }
          });
          messageSearchDispatcher({
            type: START_GETTING_SEARCHED_MESSAGES,
            payload: createdQuery
          });
        });
      } else {
        logger.info('MessageSearch | useGetSeasrchedMessages: search string is empty');
      }
    }
  }, [channelUrl, messageSearchQuery, requestString, currentChannel, retryCount]);
}
function useScrollCallback(_ref, _ref2) {
  var currentMessageSearchQuery = _ref.currentMessageSearchQuery,
    hasMoreResult = _ref.hasMoreResult,
    onResultLoaded = _ref.onResultLoaded;
  var logger = _ref2.logger,
    messageSearchDispatcher = _ref2.messageSearchDispatcher;
  return useCallback(function (cb) {
    if (!hasMoreResult) {
      logger.warning('MessageSearch | useScrollCallback: no more searched results', hasMoreResult);
    }
    if (currentMessageSearchQuery && currentMessageSearchQuery.hasNext) {
      currentMessageSearchQuery.next().then(function (messages) {
        logger.info('MessageSearch | useScrollCallback: succeeded getting searched messages', messages);
        messageSearchDispatcher({
          type: GET_NEXT_SEARCHED_MESSAGES,
          payload: messages
        });
        cb(messages, null);
        if (onResultLoaded && typeof onResultLoaded === 'function') {
          onResultLoaded(messages, null);
        }
      }).catch(function (error) {
        logger.warning('MessageSearch | useScrollCallback: failed getting searched messages', error);
        cb(null, error);
        if (onResultLoaded && typeof onResultLoaded === 'function') {
          onResultLoaded(null, error);
        }
      });
    } else {
      logger.warning('MessageSearch | useScrollCallback: no currentMessageSearchQuery');
    }
  }, [currentMessageSearchQuery, hasMoreResult]);
}
var DEBOUNCING_TIME = 500;
function useSearchStringEffect(_ref, _ref2) {
  var searchString = _ref.searchString;
  var messageSearchDispatcher = _ref2.messageSearchDispatcher;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    requestString = _useState2[0],
    setRequestString = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    debouncingTimer = _useState4[0],
    setDebouncingTimer = _useState4[1];
  useEffect(function () {
    clearTimeout(debouncingTimer);
    if (searchString) {
      setDebouncingTimer(setTimeout(function () {
        setRequestString(searchString);
      }, DEBOUNCING_TIME));
    } else {
      setRequestString('');
      messageSearchDispatcher({
        type: RESET_SEARCH_STRING,
        payload: ''
      });
    }
  }, [searchString]);
  return requestString;
}
var MessageSearchContext = /*#__PURE__*/React__default.createContext(undefined);
var MessageSearchProvider = function MessageSearchProvider(props) {
  var _globalState$config, _globalState$stores, _globalState$stores$s, _globalState$stores2, _globalState$stores2$;
  var channelUrl = props.channelUrl,
    searchString = props.searchString,
    messageSearchQuery = props.messageSearchQuery,
    onResultLoaded = props.onResultLoaded,
    onResultClick = props.onResultClick;
  var globalState = useSendbirdStateContext();

  // hook variables
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    retryCount = _useState6[0],
    setRetryCount = _useState6[1]; // this is a trigger flag for activating useGetSearchMessages
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedMessageId = _useState8[0],
    setSelectedMessageId = _useState8[1];
  var _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    messageSearchStore = _useReducer2[0],
    messageSearchDispatcher = _useReducer2[1];
  var allMessages = messageSearchStore.allMessages,
    loading = messageSearchStore.loading,
    isInvalid = messageSearchStore.isInvalid,
    currentChannel = messageSearchStore.currentChannel,
    currentMessageSearchQuery = messageSearchStore.currentMessageSearchQuery,
    hasMoreResult = messageSearchStore.hasMoreResult;
  var logger = globalState === null || globalState === void 0 ? void 0 : (_globalState$config = globalState.config) === null || _globalState$config === void 0 ? void 0 : _globalState$config.logger;
  var sdk = globalState === null || globalState === void 0 ? void 0 : (_globalState$stores = globalState.stores) === null || _globalState$stores === void 0 ? void 0 : (_globalState$stores$s = _globalState$stores.sdkStore) === null || _globalState$stores$s === void 0 ? void 0 : _globalState$stores$s.sdk;
  var sdkInit = globalState === null || globalState === void 0 ? void 0 : (_globalState$stores2 = globalState.stores) === null || _globalState$stores2 === void 0 ? void 0 : (_globalState$stores2$ = _globalState$stores2.sdkStore) === null || _globalState$stores2$ === void 0 ? void 0 : _globalState$stores2$.initialized;
  var scrollRef = useRef(null);
  var handleOnScroll = function handleOnScroll(e) {
    var scrollElement = e.target;
    var scrollTop = scrollElement.scrollTop,
      scrollHeight = scrollElement.scrollHeight,
      clientHeight = scrollElement.clientHeight;
    if (!hasMoreResult) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      onScroll(function () {
        // after load more searched messages
      });
    }
  };
  useSetChannel({
    channelUrl: channelUrl,
    sdkInit: sdkInit
  }, {
    sdk: sdk,
    logger: logger,
    messageSearchDispatcher: messageSearchDispatcher
  });
  var requestString = useSearchStringEffect({
    searchString: searchString
  }, {
    messageSearchDispatcher: messageSearchDispatcher
  });
  useGetSearchedMessages({
    currentChannel: currentChannel,
    channelUrl: channelUrl,
    requestString: requestString,
    messageSearchQuery: messageSearchQuery,
    onResultLoaded: onResultLoaded,
    retryCount: retryCount
  }, {
    sdk: sdk,
    logger: logger,
    messageSearchDispatcher: messageSearchDispatcher
  });
  var onScroll = useScrollCallback({
    currentMessageSearchQuery: currentMessageSearchQuery,
    hasMoreResult: hasMoreResult,
    onResultLoaded: onResultLoaded
  }, {
    logger: logger,
    messageSearchDispatcher: messageSearchDispatcher
  });
  var handleRetryToConnect = function handleRetryToConnect() {
    setRetryCount(retryCount + 1);
  };
  return /*#__PURE__*/React__default.createElement(MessageSearchContext.Provider, {
    value: {
      channelUrl: channelUrl,
      searchString: searchString,
      requestString: requestString,
      messageSearchQuery: messageSearchQuery,
      onResultLoaded: onResultLoaded,
      onResultClick: onResultClick,
      retryCount: retryCount,
      setRetryCount: setRetryCount,
      selectedMessageId: selectedMessageId,
      setSelectedMessageId: setSelectedMessageId,
      messageSearchDispatcher: messageSearchDispatcher,
      allMessages: allMessages,
      loading: loading,
      isInvalid: isInvalid,
      currentChannel: currentChannel,
      currentMessageSearchQuery: currentMessageSearchQuery,
      hasMoreResult: hasMoreResult,
      onScroll: onScroll,
      scrollRef: scrollRef,
      handleRetryToConnect: handleRetryToConnect,
      handleOnScroll: handleOnScroll
    }
  }, props === null || props === void 0 ? void 0 : props.children);
};
var useMessageSearchContext = function useMessageSearchContext() {
  return React__default.useContext(MessageSearchContext);
};
export { MessageSearchProvider, useMessageSearchContext };